import React from 'react';
import { Modal, Button } from '@prosolve/common-components-ui'

const DEFAULT_WARNING = 'This changes the asset\'s public URL. Any existing links, embeds, or documents pointing to the old URL will stop working.'

export default ({
  title = 'Are you sure?',
  message = '',
  warningText = DEFAULT_WARNING,
  confirmLabel = 'Continue',
  onClose,
  onConfirm
}) => {

  const footer = (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onConfirm} $colored={true}>
        {confirmLabel}
      </Button>
    </div>
  )

  return (
    <Modal title={title} isAutoHeight={true} closeOnOffClick={false} onClose={onClose} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}>
        {message && <div>{message}</div>}
        <div style={{
          padding: '10px',
          background: '#fff7e6',
          border: '1px solid #fa8900',
          borderRadius: '5px',
          color: '#565656'
        }}>
          {warningText}
        </div>
        <div>{'Do you wish to proceed?'}</div>
      </div>
    </Modal>
  )
}
